import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function usePayPreferenceFilterSettings() {
  return useCbhFlag(CbhFeatureFlag.PAY_PREFERENCE_FILTER_SETTINGS, {
    defaultValue: {
      enabled: false,
      qualificationRanges: {},
    },
  });
}
